import { render, staticRenderFns } from "./ChargeList.vue?vue&type=template&id=522004de&scoped=true"
import script from "./ChargeList.vue?vue&type=script&lang=js"
export * from "./ChargeList.vue?vue&type=script&lang=js"
import style0 from "./ChargeList.vue?vue&type=style&index=0&id=522004de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522004de",
  null
  
)

export default component.exports